export default (state = [], action) => {
    
    switch (action.type){
        case 'SOLUTION_NEWTON':
            return action.payload;
        default:
            return [];
    }
};